import React from "react";
import MtiButton from "../../Buttons/MtiButton";

type Props = {
  title: string;
  onCollapseExpandItem: () => void;
  isAllCollapsed: boolean;
  showCollapseExpand: boolean;
};

export default function PreferenceTitle({
  title,
  onCollapseExpandItem,
  isAllCollapsed,
  showCollapseExpand,
}: Props) {
  return (
    <div className="preference-title">
      <div>
        <div className="text-title">{title}</div>
      </div>
      <div style={{ display: "flex", alignItems: "flex-end" }}>
        {showCollapseExpand && (
          <MtiButton
            onClick={onCollapseExpandItem}
            size="small"
            variant="secondary"
            style={{ paddingLeft: 13, paddingRight: 13 }}
          >
            {isAllCollapsed && (
              <>
                EXPAND ALL
                <svg
                  width="14"
                  height="8"
                  viewBox="0 0 14 8"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  style={{ marginLeft: 13 }}
                >
                  <path
                    d="M0.583374 1.37484L7.00004 7.7915L13.4167 1.37484L12.25 0.208172L7.00004 5.45817L1.75004 0.208172L0.583374 1.37484Z"
                    fill="#F7A246"
                  />
                </svg>
              </>
            )}
            {!isAllCollapsed && (
              <>
                COLLAPSE ALL
                <svg
                  width="14"
                  height="9"
                  viewBox="0 0 14 9"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  style={{ marginLeft: 13 }}
                >
                  <path
                    d="M0.583252 6.91683L6.99992 0.500162L13.4166 6.91683L12.2499 8.0835L6.99992 2.8335L1.74992 8.0835L0.583252 6.91683Z"
                    fill="#F7A246"
                  />
                </svg>
              </>
            )}
          </MtiButton>
        )}
      </div>
    </div>
  );
}
